module.exports = __webpack_public_path__ + "img/transformselect_cn.27c647f.jpg";